module.exports = __webpack_public_path__ + "static/img/p11.9ad5640.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/p11.png
// module id = kVhH
// module chunks = 0